import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Survey\DeleteSurveyController::deleteMethod
* @see app/Http/Controllers/Survey/DeleteSurveyController.php
* @route '/api/survey/survey-delete/{survey}'
*/
export const deleteMethod = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/survey/survey-delete/{survey}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Survey\DeleteSurveyController::deleteMethod
* @see app/Http/Controllers/Survey/DeleteSurveyController.php
* @route '/api/survey/survey-delete/{survey}'
*/
deleteMethod.url = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { survey: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { survey: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            survey: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        survey: typeof args.survey === 'object'
        ? args.survey.id
        : args.survey,
    }

    return deleteMethod.definition.url
            .replace('{survey}', parsedArgs.survey.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Survey\DeleteSurveyController::deleteMethod
* @see app/Http/Controllers/Survey/DeleteSurveyController.php
* @route '/api/survey/survey-delete/{survey}'
*/
deleteMethod.delete = (args: { survey: string | number | { id: string | number } } | [survey: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Survey\DeleteSurveyController::undo
* @see app/Http/Controllers/Survey/DeleteSurveyController.php
* @route '/api/survey/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/survey/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Survey\DeleteSurveyController::undo
* @see app/Http/Controllers/Survey/DeleteSurveyController.php
* @route '/api/survey/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Survey\DeleteSurveyController::undo
* @see app/Http/Controllers/Survey/DeleteSurveyController.php
* @route '/api/survey/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Survey\DeleteSurveyController::undo
* @see app/Http/Controllers/Survey/DeleteSurveyController.php
* @route '/api/survey/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteSurveyController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteSurveyController